import React, { useState } from "react";
import "./formPassInput.scss"
import { useField } from "formik";
import {ReactComponent as EyeIcon} from '../../../assets/icons/eye-solid.svg';
import {ReactComponent as EyeSlashIcon} from '../../../assets/icons/eye-slash-solid.svg';


const FormPassInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const [passwordMode, setPasswordMode] = useState(true);
    const togglePassInput = () => {
        
        if (passwordMode) {
            setPasswordMode(false);
        } else {
            setPasswordMode(true);
        }
    }
    return (
        <div className="signup__input">
            <label>{label}</label>
            { passwordMode 
                ? <input className={meta.error && "error"} {...field} {...props} type="password" />
                : <input className={meta.error && "error"} {...field} {...props} type="text" /> 
            }
            <i onClick={togglePassInput}>
                { passwordMode ? <EyeSlashIcon /> : <EyeIcon /> }
            </i>

            {meta.touched && meta.error && <p>{meta.error}</p>}
        </div>
    )
};

export default FormPassInput;